import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { PaymentProvider } from '@model/PaymentProviderDto'

import { Notice } from '@shared/components/Notice'

const paymentProviderMethods = [
  { name: 'SC Alogateway CUP', message: 'china info' },
  { name: 'SC Transact365 CNY', message: 'This payment provider channel is' },
]

interface FundingFormWarningNoteProps {
  paymentProvider: PaymentProvider
}

export const hasFundingFormWarningNote = (paymentProvider?: PaymentProvider): boolean => {
  return !!paymentProviderMethods.find(
    (paymentProviderMethod) => paymentProvider?.method_name === paymentProviderMethod.name
  )
}

const getWarningMessageKey = (paymentProvider: PaymentProvider): string | undefined => {
  return paymentProviderMethods.find(
    (paymentProviderMethod) => paymentProvider.method_name === paymentProviderMethod.name
  )?.message
}

export const FundingFormWarningNote: FC<FundingFormWarningNoteProps> = ({ paymentProvider }) => {
  const { t } = useTranslation()
  const messageKey = getWarningMessageKey(paymentProvider)

  if (!messageKey) {
    return null
  }

  return (
    <Notice
      id='deposit-form-warning-note'
      type='warning'
      title={t('Note')}
      message={t(messageKey)}
    />
  )
}
